<template>
  <div class="club-summary-burns">
    <div class="club-summary-burns__inner">
      <div class="club-summary-burns__points">
        -{{ points | price }}
      </div>
      <div class="club-summary-burns__caption">
        сгорают {{ expiresAt }}
      </div>
    </div>
  </div>
</template>

<script>
import { ddmmyyyy } from '@/utils/date-to-string';

export default {
  name: "club-summary-burns",

  props: {
    points: {
      type: [Number, String],
      default: 0,
    },
    date: {
      type: String,
      required: true,
    },
  },

  computed: {
    expiresAt() {
      return ddmmyyyy(new Date(this.date));
    },
  }
}
</script>

<style lang="scss">
  $offset: 18px;

  .club-summary-burns {
    &__points {
      font-size: 14px;
      line-height: 18px;
      color: $purple;
      font-weight: bold;
      margin-left: $offset;

      @include breakpoint("tablet") {
        font-size: 16px;
      }

      &::before {
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 7px 4px 0;
        border-color: #a80f7a transparent transparent transparent;
        margin-right: 4px;
        margin-left: -$offset;
      }
    }

    &__caption {
      font-size: 12px;
      margin-left: $offset;

      @include breakpoint("tablet") {
        font-size: 14px;
      }
    }
  }
</style>